// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2eWXn","amount":"Amount_amount__Fzld6","tip":"Amount_tip__2Ti00","tipHeader":"Amount_tipHeader__3CI6O","tipsWrap":"Amount_tipsWrap__1A-cv"};